import { UseMutationResult, useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";

import axiosInstance from "../../shared/service/axios";
import { CustomerRetrievalResponse } from "./Receivable.constants";

export const useCustomersRetrievalsListMutation = (): UseMutationResult<
  CustomerRetrievalResponse,
  AxiosError,
  any
> =>
  useMutation<CustomerRetrievalResponse, AxiosError, any>(async () => {
    const { data, status } = await axiosInstance.get("customer/retrieval/", {
      params: {
        page_size: 999999,
      },
    });

    return data;
  });
